import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useDataProvider } from "../context/DataContext";
import {
  getAllProductsFromAtakentHttp,
  getAllProductsFromGoztepeHttp,
} from "../services/CategoryService";
import BackdropLoading from "../components/display/BackdropLoading";

const pagination = {
  page: 1,
  pageSize: 1000,
  conditions: [],
};

function Layout() {
  const { branch } = useParams();
  const { data, setData } = useDataProvider();
  const [loading, setLoading] = useState(false)  
  const [isVisible, setIsVisible] = useState(false)  

  useEffect(() => {
    if (branch === "goztepe"){
      setLoading(true);
      getAllProductsFromGoztepeHttp(pagination).then((resp) => {
        setData(resp.data);
      }).finally(()=>setLoading(false));
    }
    else if (branch === "atakent"){
      setLoading(true);
      getAllProductsFromAtakentHttp(pagination).then((resp) => {
        setData(resp.data);
      }).finally(()=>setLoading(false));
    }
  }, [branch]);

  return (
    <main>
      {!loading && <section className="menu section">
        <div className="title" style={{
          paddingBottom: ".25rem",
          position: "sticky",
          top: 0,
          zIndex: !loading && 9999,
          backgroundColor: "hsl(210, 36%, 96%)",
          // boxShadow: data.length>1 && "0px 15px 10px -15px rgba(0,0,0,0.43)",
          // boxShadow: "0px 6px 32px -6px rgba(0,0,0,0.43)",
          // "-webkit-box-shadow": "0px 6px 32px -6px rgba(0,0,0,0.43)",
          // "-moz-box-shadow": "0px 6px 32px -6px rgba(0,0,0,0.43)"
        }}>
          <img
            src="./images/brand.png"
            alt="eylul-brand-photo"
            style={{ ml: 5 }}
            width={100}
          />
          <Typography className="subtitle" paddingBottom={1} color="black">
            1993'ten bu yana aynı lezzet...
          </Typography>
          <Box className="underline" />
        </div>
        <Outlet />
        {/* {document.documentElement.scrollTop > 100 && 
        <Button
          sx={{
            position:"fixed",
            bottom: "1.5rem",
            right: "1.5rem"
          }}
          variant="contained"
          onClick={() => {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          }}
        >
          Scroll to top
        </Button>
        } */}
      </section>}
      <BackdropLoading loading={loading} />
    </main>
  );
}

export default Layout;
